export const environment = {
  production: false,
  apiUrl: 'https://sky-mpi-uat-finance-fa-suppliersearch.azurewebsites.net/api/suppliers',
  functionKey: 'L0_NzNHerA3oC8G_2tjOpC3RUncLBYRUNR1GuaY4oXniAzFujJxTDQ==',
  appUrl: 'https://sky.uat.supplier.middleware.sky'
};
